import { Modal, Table } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import BaseTable from "#/components/tables/BaseTable";
import { usePrvTranslation } from "#/pages/ClientDetail/components/prv/usePrvTranslation";
import type { LogisticsPrediction, PredictionSettings } from "#/types/prediction";

interface Props {
  opened: boolean;
  onClose: () => void;
  rows: LogisticsPrediction[];
  settings: PredictionSettings;
}

/** The sub-clients the engine cannot predict for, each with the reason and where to fix it. */
const NotPredictableModal = ({ opened, onClose, rows, settings }: Props) => {
  const t = usePrvTranslation();
  const navigate = useNavigate();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("predictedDeliveries.notPredictable.title", { count: rows.length })}
      size="lg"
    >
      <p className="mb-3 text-xs text-gray-600">{t("predictedDeliveries.notPredictable.intro")}</p>
      <BaseTable
        headers={[
          t("predictedDeliveries.notPredictable.subClient"),
          t("predictedDeliveries.notPredictable.reason"),
        ]}
        rows={rows.map((row) => (
          <Table.Tr key={row.id}>
            <Table.Td>
              <button
                type="button"
                className="text-blue-700 underline-offset-2 hover:underline"
                onClick={() => void navigate(`/sub-clients/${row.subClient.id}`)}
              >
                {row.subClient.name}
              </button>
            </Table.Td>
            <Table.Td className="text-sm text-gray-700">
              {row.reason
                ? t(`predictedDeliveries.notPredictable.reasons.${row.reason}`, {
                    visits: row.visits,
                    min: settings.minDeliveries,
                  })
                : "--"}
            </Table.Td>
          </Table.Tr>
        ))}
      />
    </Modal>
  );
};

export default NotPredictableModal;
